<template>
    <div ref="make_request_join_form_popup_wrap">
        <MakeRequestJoinForm :soccerhowIdx="soccerhowIdx" :isFromReportList="true" :isHideBackBtn="true" :isShowMakeRequestJoinForm="isOpen" :closeRequestJoinForm="closeAction"></MakeRequestJoinForm>
    </div>
</template>

<script>
    import MakeRequestJoinForm from "./MakeRequestJoinForm";
    export default {
        name: "MakeRequestJoinFormPopup",
        components: {MakeRequestJoinForm},
        props : {
            soccerhowIdx : {
                type: [Number, String],
                default: -1
            },
            isFromReportList: {
                type: Boolean,
                default: false
            },
        },
        data(){
            return {
                isOpen : false,
            }
        },
        mounted(){
            this.$refs.make_request_join_form_popup_wrap.parentElement.style.zIndex = 301;

            setTimeout(() => {
                this.isOpen = true;
            }, 0)
        },
        methods : {
            closeAction() {
                if(this.isOpen) {
                    this.isOpen = false;
                }
                setTimeout(() => {
                    this.$GlobalStore.closeLastModal();
                }, 300)
            },
        },
        created() {

        }
    }
</script>

<style scoped>

</style>